import {schema} from "../../module/config/schema";
import {nanoid} from "nanoid";

import {FileAttrs, FileNode, ImageNode} from "../../module/schema";

export const createFileUploadingPlaceholder = (file: File, originalFileName: string) => {
    const localUrl = URL.createObjectURL(file); // blob:https://localhost...
    return schema.node(
        "file",
        {
            src: localUrl,
            title: originalFileName,
            guid: nanoid(6),
        }
    ) as FileNode;
}

export const copyFileNode = (node: FileNode | ImageNode, attributesOverride: Partial<FileAttrs> = {}) => {
    return schema.nodes.file.create(
        {
            ...node.attrs,
            guid: nanoid(6),
            ...attributesOverride,
        },
        node.content,
        node.marks,
    ) as FileNode;
}